<template>
  <el-dialog class="updateImg"
             :visible.sync="updateImgVisible"
             :close-on-click-modal="false"
             @closed="closeDialog"
             width="1000px"
             :title="$t('goodsList.updateImg.dialogTitle')"
             :lock-scroll="false"
             :modal-append-to-body="false"
             append-to-body>
    <el-form label-width="100px" @keydown.enter.native.prevent>
      <el-form-item label-width="0">
        <imgUpload :images="images"
                   @imagesChange="imagesChange"
                   :width="148"
                   :height="148"
                   :multiple="true"
                   ref="uploadRef"
                   :type="type" />
      </el-form-item>
    </el-form>

    <span slot="footer"
          class="dialog-footer">
      <el-button size="small"
                 v-if="type!=='detail'"
                 type="primary"
                 @click="save">{{$t('goodsList.updateImg.save')}}</el-button>
      <el-button size="small"
                 v-else
                 @click="updateImgVisible = false">{{$t('goodsList.updateImg.close')}}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import imgUpload from "@/common/components/imgUpload";
export default {
    data() {
        return {
            images: [],
            tableItemIndex: "",
        };
    },
    methods: {
        save() {
            this.$emit("update:tableItemIndex", this.tableItemIndex);
            this.$emit("imgUrl", this.images);
            this.closeDialog();
        },
        closeDialog() {
            this.images = [];
            if (this.type !== "detail") {
                this.$refs.uploadRef.clear();
            }
            this.$emit("update:updateImgVisible", false);
        },
        imagesChange(imgList) {
            this.images = imgList;
        },
    },
    components: {
        imgUpload: imgUpload,
    },
    props: {
        updateImgVisible: Boolean,
        tableItemIndex: Number,
        imagesList: Array,
        type: String,
    },
    computed: {
        mixed() {
            const { tableItemIndex, updateImgVisible, imagesList } = this;
            return {
                tableItemIndex,
                updateImgVisible,
                imagesList,
            };
        },
    },
    watch: {
        mixed: {
            handler(newValue) {
                if (newValue.updateImgVisible) {
                    this.images = newValue.imagesList;
                    this.tableItemIndex = newValue.tableItemIndex;
                }
            },
            deep: true,
            immediate: true,
        },
    },
};
</script>
<style lang="scss">
.updateImg {
    width: 100%;
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        float: left;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409eff;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 148px;
        height: 148px;
        line-height: 148px;
        text-align: center;
    }
    .avatar {
        width: 148px;
        height: 148px;
        display: block;
    }
    .el-upload--picture-card {
        float: left !important;
        margin-right: 10px;
    }
    .uploadBox {
        .el-upload,
        .el-upload--text {
            width: 100%;
            height: 100%;
        }
    }
}
</style>